// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n", "",{"version":3,"sources":["webpack://./components/theme/antdVariables.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F","sourcesContent":["@import '~antd/lib/style/themes/default.less';\n@import '../../styles/theme.less';\n\n:export {\n  // Custom exports:\n  boxShadowColor: @box-shadow-color;\n  boxShadowHorLength: @box-shadow-hor-length;\n  boxShadowVerLength: @box-shadow-ver-length;\n  boxShadowBlur: @box-shadow-blur;\n  boxShadowSpread: @box-shadow-spread;\n  iconSize: @base-icon-size;\n  pageBlurRadius: @page-blur-radius;\n\n  grayBase: @gray-base;\n  gray1: @gray-1;\n  gray2: @gray-2;\n  gray3: @gray-3;\n  gray4: @gray-4;\n  gray5: @gray-5;\n  gray6: @gray-6;\n  gray7: @gray-7;\n  gray8: @gray-8;\n  gray9: @gray-9;\n  gray10: @gray-10;\n\n  alpha45: @alpha-45;\n  alpha85: @alpha-85;\n\n  // Antd's variables (do not edit):\n  blueBase: @blue-base;\n  blue1: @blue-1;\n  blue2: @blue-2;\n  blue3: @blue-3;\n  blue4: @blue-4;\n  blue5: @blue-5;\n  blue6: @blue-6;\n  blue7: @blue-7;\n  blue8: @blue-8;\n  blue9: @blue-9;\n  blue10: @blue-10;\n  purpleBase: @purple-base;\n  purple1: @purple-1;\n  purple2: @purple-2;\n  purple3: @purple-3;\n  purple4: @purple-4;\n  purple5: @purple-5;\n  purple6: @purple-6;\n  purple7: @purple-7;\n  purple8: @purple-8;\n  purple9: @purple-9;\n  purple10: @purple-10;\n  cyanBase: @cyan-base;\n  cyan1: @cyan-1;\n  cyan2: @cyan-2;\n  cyan3: @cyan-3;\n  cyan4: @cyan-4;\n  cyan5: @cyan-5;\n  cyan6: @cyan-6;\n  cyan7: @cyan-7;\n  cyan8: @cyan-8;\n  cyan9: @cyan-9;\n  cyan10: @cyan-10;\n  greenBase: @green-base;\n  green1: @green-1;\n  green2: @green-2;\n  green3: @green-3;\n  green4: @green-4;\n  green5: @green-5;\n  green6: @green-6;\n  green7: @green-7;\n  green8: @green-8;\n  green9: @green-9;\n  green10: @green-10;\n  magentaBase: @magenta-base;\n  magenta1: @magenta-1;\n  magenta2: @magenta-2;\n  magenta3: @magenta-3;\n  magenta4: @magenta-4;\n  magenta5: @magenta-5;\n  magenta6: @magenta-6;\n  magenta7: @magenta-7;\n  magenta8: @magenta-8;\n  magenta9: @magenta-9;\n  magenta10: @magenta-10;\n  pinkBase: @pink-base;\n  pink1: @pink-1;\n  pink2: @pink-2;\n  pink3: @pink-3;\n  pink4: @pink-4;\n  pink5: @pink-5;\n  pink6: @pink-6;\n  pink7: @pink-7;\n  pink8: @pink-8;\n  pink9: @pink-9;\n  pink10: @pink-10;\n  redBase: @red-base;\n  red1: @red-1;\n  red2: @red-2;\n  red3: @red-3;\n  red4: @red-4;\n  red5: @red-5;\n  red6: @red-6;\n  red7: @red-7;\n  red8: @red-8;\n  red9: @red-9;\n  red10: @red-10;\n  orangeBase: @orange-base;\n  orange1: @orange-1;\n  orange2: @orange-2;\n  orange3: @orange-3;\n  orange4: @orange-4;\n  orange5: @orange-5;\n  orange6: @orange-6;\n  orange7: @orange-7;\n  orange8: @orange-8;\n  orange9: @orange-9;\n  orange10: @orange-10;\n  yellowBase: @yellow-base;\n  yellow1: @yellow-1;\n  yellow2: @yellow-2;\n  yellow3: @yellow-3;\n  yellow4: @yellow-4;\n  yellow5: @yellow-5;\n  yellow6: @yellow-6;\n  yellow7: @yellow-7;\n  yellow8: @yellow-8;\n  yellow9: @yellow-9;\n  yellow10: @yellow-10;\n  volcanoBase: @volcano-base;\n  volcano1: @volcano-1;\n  volcano2: @volcano-2;\n  volcano3: @volcano-3;\n  volcano4: @volcano-4;\n  volcano5: @volcano-5;\n  volcano6: @volcano-6;\n  volcano7: @volcano-7;\n  volcano8: @volcano-8;\n  volcano9: @volcano-9;\n  volcano10: @volcano-10;\n  geekblueBase: @geekblue-base;\n  geekblue1: @geekblue-1;\n  geekblue2: @geekblue-2;\n  geekblue3: @geekblue-3;\n  geekblue4: @geekblue-4;\n  geekblue5: @geekblue-5;\n  geekblue6: @geekblue-6;\n  geekblue7: @geekblue-7;\n  geekblue8: @geekblue-8;\n  geekblue9: @geekblue-9;\n  geekblue10: @geekblue-10;\n  limeBase: @lime-base;\n  lime1: @lime-1;\n  lime2: @lime-2;\n  lime3: @lime-3;\n  lime4: @lime-4;\n  lime5: @lime-5;\n  lime6: @lime-6;\n  lime7: @lime-7;\n  lime8: @lime-8;\n  lime9: @lime-9;\n  lime10: @lime-10;\n  goldBase: @gold-base;\n  gold1: @gold-1;\n  gold2: @gold-2;\n  gold3: @gold-3;\n  gold4: @gold-4;\n  gold5: @gold-5;\n  gold6: @gold-6;\n  gold7: @gold-7;\n  gold8: @gold-8;\n  gold9: @gold-9;\n  gold10: @gold-10;\n  neutralBase: @neutral-base;\n  neutral1: @neutral-1;\n  neutral2: @neutral-2;\n  neutral3: @neutral-3;\n  neutral4: @neutral-4;\n  neutral5: @neutral-5;\n  neutral6: @neutral-6;\n  neutral7: @neutral-7;\n  neutral8: @neutral-8;\n  neutral9: @neutral-9;\n  neutral10: @neutral-10;\n\n  presetColors: @preset-colors;\n\n  primaryColor: @primary-color;\n  infoColor: @info-color;\n  successColor: @success-color;\n  processingColor: @processing-color;\n  errorColor: @error-color;\n  highlightColor: @highlight-color;\n  warningColor: @warning-color;\n  normalColor: @normal-color;\n  white: @white;\n  black: @black;\n  primary1: @primary-1;\n  primary2: @primary-2;\n  primary3: @primary-3;\n  primary4: @primary-4;\n  primary5: @primary-5;\n  primary6: @primary-6;\n  primary7: @primary-7;\n  primary8: @primary-8;\n  primary9: @primary-9;\n  primary10: @primary-10;\n  bodyBackground: @body-background;\n  componentBackground: @component-background;\n  popoverBackground: @popover-background;\n  popoverCustomizeBorderColor: @popover-customize-border-color;\n  fontFamily: @font-family;\n  codeFamily: @code-family;\n  textColor: @text-color;\n  textColorSecondary: @text-color-secondary;\n  textColorInverse: @text-color-inverse;\n  iconColor: @icon-color;\n  iconColorHover: @icon-color-hover;\n  headingColor: @heading-color;\n  textColorDark: @text-color-dark;\n  textColorSecondaryDark: @text-color-secondary-dark;\n  textSelectionBg: @text-selection-bg;\n  fontVariantBase: @font-variant-base;\n  fontFeatureSettingsBase: @font-feature-settings-base;\n  fontSizeBase: @font-size-base;\n  fontSizeLg: @font-size-lg;\n  fontSizeSm: @font-size-sm;\n  heading1Size: @heading-1-size;\n  heading2Size: @heading-2-size;\n  heading3Size: @heading-3-size;\n  heading4Size: @heading-4-size;\n  heading5Size: @heading-5-size;\n  lineHeightBase: @line-height-base;\n  borderRadiusBase: @border-radius-base;\n  borderRadiusSm: @border-radius-sm;\n  paddingLg: @padding-lg;\n  paddingMd: @padding-md;\n  paddingSm: @padding-sm;\n  paddingXs: @padding-xs;\n  paddingXss: @padding-xss;\n  controlPaddingHorizontal: @control-padding-horizontal;\n  controlPaddingHorizontalSm: @control-padding-horizontal-sm;\n  marginLg: @margin-lg;\n  marginMd: @margin-md;\n  marginSm: @margin-sm;\n  marginXs: @margin-xs;\n  marginXss: @margin-xss;\n  heightBase: @height-base;\n  heightLg: @height-lg;\n  heightSm: @height-sm;\n  itemActiveBg: @item-active-bg;\n  itemHoverBg: @item-hover-bg;\n  iconfontCssPrefix: @iconfont-css-prefix;\n  linkColor: @link-color;\n  linkHoverColor: @link-hover-color;\n  linkActiveColor: @link-active-color;\n  linkDecoration: @link-decoration;\n  linkHoverDecoration: @link-hover-decoration;\n  linkFocusDecoration: @link-focus-decoration;\n  linkFocusOutline: @link-focus-outline;\n  easeBaseOut: @ease-base-out;\n  easeBaseIn: @ease-base-in;\n  easeOut: @ease-out;\n  easeIn: @ease-in;\n  easeInOut: @ease-in-out;\n  easeOutBack: @ease-out-back;\n  easeInBack: @ease-in-back;\n  easeInOutBack: @ease-in-out-back;\n  easeOutCirc: @ease-out-circ;\n  easeInCirc: @ease-in-circ;\n  easeInOutCirc: @ease-in-out-circ;\n  easeOutQuint: @ease-out-quint;\n  easeInQuint: @ease-in-quint;\n  easeInOutQuint: @ease-in-out-quint;\n  borderColorBase: @border-color-base;\n  borderColorSplit: @border-color-split;\n  borderColorInverse: @border-color-inverse;\n  borderWidthBase: @border-width-base;\n  borderStyleBase: @border-style-base;\n  outlineBlurSize: @outline-blur-size;\n  outlineWidth: @outline-width;\n  outlineColor: @outline-color;\n  outlineFade: @outline-fade;\n  backgroundColorLight: @background-color-light;\n  backgroundColorBase: @background-color-base;\n  disabledColor: @disabled-color;\n  disabledBg: @disabled-bg;\n  disabledColorDark: @disabled-color-dark;\n  shadowColor: @shadow-color;\n  shadowColorInverse: @shadow-color-inverse;\n  boxShadowBase: @box-shadow-base;\n  shadow1Up: @shadow-1-up;\n  shadow1Down: @shadow-1-down;\n  shadow1Left: @shadow-1-left;\n  shadow1Right: @shadow-1-right;\n  shadow2: @shadow-2;\n  btnFontWeight: @btn-font-weight;\n  btnBorderRadiusBase: @btn-border-radius-base;\n  btnBorderRadiusSm: @btn-border-radius-sm;\n  btnBorderWidth: @btn-border-width;\n  btnBorderStyle: @btn-border-style;\n  btnShadow: @btn-shadow;\n  btnPrimaryShadow: @btn-primary-shadow;\n  btnTextShadow: @btn-text-shadow;\n  btnPrimaryColor: @btn-primary-color;\n  btnPrimaryBg: @btn-primary-bg;\n  btnDefaultColor: @btn-default-color;\n  btnDefaultBg: @btn-default-bg;\n  btnDefaultBorder: @btn-default-border;\n  btnDangerColor: @btn-danger-color;\n  btnDangerBg: @btn-danger-bg;\n  btnDangerBorder: @btn-danger-border;\n  btnDisableColor: @btn-disable-color;\n  btnDisableBg: @btn-disable-bg;\n  btnDisableBorder: @btn-disable-border;\n  btnDefaultGhostColor: @btn-default-ghost-color;\n  btnDefaultGhostBg: @btn-default-ghost-bg;\n  btnDefaultGhostBorder: @btn-default-ghost-border;\n  btnFontSizeLg: @btn-font-size-lg;\n  btnFontSizeSm: @btn-font-size-sm;\n  btnPaddingHorizontalBase: @btn-padding-horizontal-base;\n  btnPaddingHorizontalLg: @btn-padding-horizontal-lg;\n  btnPaddingHorizontalSm: @btn-padding-horizontal-sm;\n  btnHeightBase: @btn-height-base;\n  btnHeightLg: @btn-height-lg;\n  btnHeightSm: @btn-height-sm;\n  btnLineHeight: @btn-line-height;\n  btnCircleSize: @btn-circle-size;\n  btnCircleSizeLg: @btn-circle-size-lg;\n  btnCircleSizeSm: @btn-circle-size-sm;\n  btnSquareSize: @btn-square-size;\n  btnSquareSizeLg: @btn-square-size-lg;\n  btnSquareSizeSm: @btn-square-size-sm;\n  btnSquareOnlyIconSize: @btn-square-only-icon-size;\n  btnSquareOnlyIconSizeSm: @btn-square-only-icon-size-sm;\n  btnSquareOnlyIconSizeLg: @btn-square-only-icon-size-lg;\n  btnGroupBorder: @btn-group-border;\n  btnLinkHoverBg: @btn-link-hover-bg;\n  btnTextHoverBg: @btn-text-hover-bg;\n  checkboxSize: @checkbox-size;\n  checkboxColor: @checkbox-color;\n  checkboxCheckColor: @checkbox-check-color;\n  checkboxCheckBg: @checkbox-check-bg;\n  checkboxBorderWidth: @checkbox-border-width;\n  checkboxGroupItemMarginRight: @checkbox-group-item-margin-right;\n  descriptionsBg: @descriptions-bg;\n  descriptionsTitleMarginBottom: @descriptions-title-margin-bottom;\n  descriptionsDefaultPadding: @descriptions-default-padding;\n  descriptionsMiddlePadding: @descriptions-middle-padding;\n  descriptionsSmallPadding: @descriptions-small-padding;\n  descriptionsItemPaddingBottom: @descriptions-item-padding-bottom;\n  descriptionsItemTrailingColon: @descriptions-item-trailing-colon;\n  descriptionsItemLabelColonMarginRight: @descriptions-item-label-colon-margin-right;\n  descriptionsItemLabelColonMarginLeft: @descriptions-item-label-colon-margin-left;\n  descriptionsExtraColor: @descriptions-extra-color;\n  dividerTextPadding: @divider-text-padding;\n  dividerOrientationMargin: @divider-orientation-margin;\n  dividerColor: @divider-color;\n  dropdownSelectedColor: @dropdown-selected-color;\n  dropdownMenuSubmenuDisabledBg: @dropdown-menu-submenu-disabled-bg;\n  emptyFontSize: @empty-font-size;\n  radioSize: @radio-size;\n  radioTop: @radio-top;\n  radioDotColor: @radio-dot-color;\n  radioDotDisabledColor: @radio-dot-disabled-color;\n  radioSolidCheckedColor: @radio-solid-checked-color;\n  radioButtonBg: @radio-button-bg;\n  radioButtonCheckedBg: @radio-button-checked-bg;\n  radioButtonColor: @radio-button-color;\n  radioButtonHoverColor: @radio-button-hover-color;\n  radioButtonActiveColor: @radio-button-active-color;\n  radioDisabledButtonCheckedBg: @radio-disabled-button-checked-bg;\n  radioDisabledButtonCheckedColor: @radio-disabled-button-checked-color;\n  radioWrapperMarginRight: @radio-wrapper-margin-right;\n  screenXs: @screen-xs;\n  screenXsMin: @screen-xs-min;\n  screenSm: @screen-sm;\n  screenSmMin: @screen-sm-min;\n  screenMd: @screen-md;\n  screenMdMin: @screen-md-min;\n  screenLg: @screen-lg;\n  screenLgMin: @screen-lg-min;\n  screenXl: @screen-xl;\n  screenXlMin: @screen-xl-min;\n  screenXxl: @screen-xxl;\n  screenXxlMin: @screen-xxl-min;\n  screenXsMax: @screen-xs-max;\n  screenSmMax: @screen-sm-max;\n  screenMdMax: @screen-md-max;\n  screenLgMax: @screen-lg-max;\n  screenXlMax: @screen-xl-max;\n  gridColumns: @grid-columns;\n  layoutBodyBackground: @layout-body-background;\n  layoutHeaderBackground: @layout-header-background;\n  layoutHeaderHeight: @layout-header-height;\n  layoutHeaderPadding: @layout-header-padding;\n  layoutHeaderColor: @layout-header-color;\n  layoutFooterPadding: @layout-footer-padding;\n  layoutFooterBackground: @layout-footer-background;\n  layoutSiderBackground: @layout-sider-background;\n  layoutTriggerHeight: @layout-trigger-height;\n  layoutTriggerBackground: @layout-trigger-background;\n  layoutTriggerColor: @layout-trigger-color;\n  layoutZeroTriggerWidth: @layout-zero-trigger-width;\n  layoutZeroTriggerHeight: @layout-zero-trigger-height;\n  layoutSiderBackgroundLight: @layout-sider-background-light;\n  layoutTriggerBackgroundLight: @layout-trigger-background-light;\n  layoutTriggerColorLight: @layout-trigger-color-light;\n  zindexBadge: @zindex-badge;\n  zindexTableFixed: @zindex-table-fixed;\n  zindexAffix: @zindex-affix;\n  zindexBackTop: @zindex-back-top;\n  zindexPickerPanel: @zindex-picker-panel;\n  zindexPopupClose: @zindex-popup-close;\n  zindexModal: @zindex-modal;\n  zindexModalMask: @zindex-modal-mask;\n  zindexMessage: @zindex-message;\n  zindexNotification: @zindex-notification;\n  zindexPopover: @zindex-popover;\n  zindexDropdown: @zindex-dropdown;\n  zindexPicker: @zindex-picker;\n  zindexPopoconfirm: @zindex-popoconfirm;\n  zindexTooltip: @zindex-tooltip;\n  zindexImage: @zindex-image;\n  animationDurationSlow: @animation-duration-slow;\n  animationDurationBase: @animation-duration-base;\n  animationDurationFast: @animation-duration-fast;\n  collapsePanelBorderRadius: @collapse-panel-border-radius;\n  dropdownMenuBg: @dropdown-menu-bg;\n  dropdownVerticalPadding: @dropdown-vertical-padding;\n  dropdownEdgeChildVerticalPadding: @dropdown-edge-child-vertical-padding;\n  dropdownFontSize: @dropdown-font-size;\n  dropdownLineHeight: @dropdown-line-height;\n  labelRequiredColor: @label-required-color;\n  labelColor: @label-color;\n  formWarningInputBg: @form-warning-input-bg;\n  formItemMarginBottom: @form-item-margin-bottom;\n  formItemTrailingColon: @form-item-trailing-colon;\n  formVerticalLabelPadding: @form-vertical-label-padding;\n  formVerticalLabelMargin: @form-vertical-label-margin;\n  formItemLabelFontSize: @form-item-label-font-size;\n  formItemLabelHeight: @form-item-label-height;\n  formItemLabelColonMarginRight: @form-item-label-colon-margin-right;\n  formItemLabelColonMarginLeft: @form-item-label-colon-margin-left;\n  formErrorInputBg: @form-error-input-bg;\n  inputHeightBase: @input-height-base;\n  inputHeightLg: @input-height-lg;\n  inputHeightSm: @input-height-sm;\n  inputPaddingHorizontal: @input-padding-horizontal;\n  inputPaddingHorizontalBase: @input-padding-horizontal-base;\n  inputPaddingHorizontalSm: @input-padding-horizontal-sm;\n  inputPaddingHorizontalLg: @input-padding-horizontal-lg;\n  inputPaddingVerticalBase: @input-padding-vertical-base;\n  inputPaddingVerticalSm: @input-padding-vertical-sm;\n  inputPaddingVerticalLg: @input-padding-vertical-lg;\n  inputPlaceholderColor: @input-placeholder-color;\n  inputColor: @input-color;\n  inputIconColor: @input-icon-color;\n  inputBorderColor: @input-border-color;\n  inputBg: @input-bg;\n  inputNumberHoverBorderColor: @input-number-hover-border-color;\n  inputNumberHandlerActiveBg: @input-number-handler-active-bg;\n  inputNumberHandlerHoverBg: @input-number-handler-hover-bg;\n  inputNumberHandlerBg: @input-number-handler-bg;\n  inputNumberHandlerBorderColor: @input-number-handler-border-color;\n  inputAddonBg: @input-addon-bg;\n  inputHoverBorderColor: @input-hover-border-color;\n  inputDisabledBg: @input-disabled-bg;\n  inputOutlineOffset: @input-outline-offset;\n  inputIconHoverColor: @input-icon-hover-color;\n  inputDisabledColor: @input-disabled-color;\n  mentionsDropdownBg: @mentions-dropdown-bg;\n  mentionsDropdownMenuItemHoverBg: @mentions-dropdown-menu-item-hover-bg;\n  selectBorderColor: @select-border-color;\n  selectItemSelectedColor: @select-item-selected-color;\n  selectItemSelectedFontWeight: @select-item-selected-font-weight;\n  selectDropdownBg: @select-dropdown-bg;\n  selectItemSelectedBg: @select-item-selected-bg;\n  selectItemActiveBg: @select-item-active-bg;\n  selectDropdownVerticalPadding: @select-dropdown-vertical-padding;\n  selectDropdownFontSize: @select-dropdown-font-size;\n  selectDropdownLineHeight: @select-dropdown-line-height;\n  selectDropdownHeight: @select-dropdown-height;\n  selectBackground: @select-background;\n  selectClearBackground: @select-clear-background;\n  selectSelectionItemBg: @select-selection-item-bg;\n  selectSelectionItemBorderColor: @select-selection-item-border-color;\n  selectSingleItemHeightLg: @select-single-item-height-lg;\n  selectMultipleItemHeight: @select-multiple-item-height;\n  selectMultipleItemHeightLg: @select-multiple-item-height-lg;\n  selectMultipleItemSpacingHalf: @select-multiple-item-spacing-half;\n  selectMultipleDisabledBackground: @select-multiple-disabled-background;\n  selectMultipleItemDisabledColor: @select-multiple-item-disabled-color;\n  selectMultipleItemDisabledBorderColor: @select-multiple-item-disabled-border-color;\n  cascaderBg: @cascader-bg;\n  cascaderItemSelectedBg: @cascader-item-selected-bg;\n  cascaderMenuBg: @cascader-menu-bg;\n  cascaderMenuBorderColorSplit: @cascader-menu-border-color-split;\n  cascaderDropdownVerticalPadding: @cascader-dropdown-vertical-padding;\n  cascaderDropdownEdgeChildVerticalPadding: @cascader-dropdown-edge-child-vertical-padding;\n  cascaderDropdownFontSize: @cascader-dropdown-font-size;\n  cascaderDropdownLineHeight: @cascader-dropdown-line-height;\n  anchorBg: @anchor-bg;\n  anchorBorderColor: @anchor-border-color;\n  anchorLinkTop: @anchor-link-top;\n  anchorLinkLeft: @anchor-link-left;\n  anchorLinkPadding: @anchor-link-padding;\n  tooltipMaxWidth: @tooltip-max-width;\n  tooltipColor: @tooltip-color;\n  tooltipBg: @tooltip-bg;\n  tooltipArrowWidth: @tooltip-arrow-width;\n  tooltipDistance: @tooltip-distance;\n  tooltipArrowColor: @tooltip-arrow-color;\n  popoverBg: @popover-bg;\n  popoverColor: @popover-color;\n  popoverMinWidth: @popover-min-width;\n  popoverMinHeight: @popover-min-height;\n  popoverArrowWidth: @popover-arrow-width;\n  popoverArrowColor: @popover-arrow-color;\n  popoverArrowOuterColor: @popover-arrow-outer-color;\n  popoverDistance: @popover-distance;\n  popoverPaddingHorizontal: @popover-padding-horizontal;\n  modalHeaderPaddingVertical: @modal-header-padding-vertical;\n  modalHeaderPaddingHorizontal: @modal-header-padding-horizontal;\n  modalBodyPadding: @modal-body-padding;\n  modalHeaderBg: @modal-header-bg;\n  modalHeaderPadding: @modal-header-padding;\n  modalHeaderBorderWidth: @modal-header-border-width;\n  modalHeaderBorderStyle: @modal-header-border-style;\n  modalHeaderTitleLineHeight: @modal-header-title-line-height;\n  modalHeaderTitleFontSize: @modal-header-title-font-size;\n  modalHeaderBorderColorSplit: @modal-header-border-color-split;\n  modalHeaderCloseSize: @modal-header-close-size;\n  modalContentBg: @modal-content-bg;\n  modalHeadingColor: @modal-heading-color;\n  modalCloseColor: @modal-close-color;\n  modalFooterBg: @modal-footer-bg;\n  modalFooterBorderColorSplit: @modal-footer-border-color-split;\n  modalFooterBorderStyle: @modal-footer-border-style;\n  modalFooterPaddingVertical: @modal-footer-padding-vertical;\n  modalFooterPaddingHorizontal: @modal-footer-padding-horizontal;\n  modalFooterBorderWidth: @modal-footer-border-width;\n  modalMaskBg: @modal-mask-bg;\n  modalConfirmBodyPadding: @modal-confirm-body-padding;\n  progressDefaultColor: @progress-default-color;\n  progressRemainingColor: @progress-remaining-color;\n  progressTextColor: @progress-text-color;\n  progressRadius: @progress-radius;\n  progressStepsItemBg: @progress-steps-item-bg;\n  progressTextFontSize: @progress-text-font-size;\n  progressCircleTextFontSize: @progress-circle-text-font-size;\n  menuInlineToplevelItemHeight: @menu-inline-toplevel-item-height;\n  menuItemHeight: @menu-item-height;\n  menuItemGroupHeight: @menu-item-group-height;\n  menuCollapsedWidth: @menu-collapsed-width;\n  menuBg: @menu-bg;\n  menuPopupBg: @menu-popup-bg;\n  menuItemColor: @menu-item-color;\n  menuHighlightColor: @menu-highlight-color;\n  menuHighlightDangerColor: @menu-highlight-danger-color;\n  menuItemActiveBg: @menu-item-active-bg;\n  menuItemActiveDangerBg: @menu-item-active-danger-bg;\n  menuItemActiveBorderWidth: @menu-item-active-border-width;\n  menuItemGroupTitleColor: @menu-item-group-title-color;\n  menuItemVerticalMargin: @menu-item-vertical-margin;\n  menuItemFontSize: @menu-item-font-size;\n  menuItemBoundaryMargin: @menu-item-boundary-margin;\n  menuItemPadding: @menu-item-padding;\n  menuHorizontalLineHeight: @menu-horizontal-line-height;\n  menuIconMarginRight: @menu-icon-margin-right;\n  menuIconSize: @menu-icon-size;\n  menuIconSizeLg: @menu-icon-size-lg;\n  menuItemGroupTitleFontSize: @menu-item-group-title-font-size;\n  menuDarkColor: @menu-dark-color;\n  menuDarkDangerColor: @menu-dark-danger-color;\n  menuDarkBg: @menu-dark-bg;\n  menuDarkArrowColor: @menu-dark-arrow-color;\n  menuDarkHighlightColor: @menu-dark-highlight-color;\n  menuDarkItemActiveBg: @menu-dark-item-active-bg;\n  menuDarkItemActiveDangerBg: @menu-dark-item-active-danger-bg;\n  menuDarkSelectedItemIconColor: @menu-dark-selected-item-icon-color;\n  menuDarkSelectedItemTextColor: @menu-dark-selected-item-text-color;\n  menuDarkItemHoverBg: @menu-dark-item-hover-bg;\n  spinDotSizeSm: @spin-dot-size-sm;\n  spinDotSize: @spin-dot-size;\n  spinDotSizeLg: @spin-dot-size-lg;\n  tableBg: @table-bg;\n  tableHeaderBg: @table-header-bg;\n  tableHeaderColor: @table-header-color;\n  tableHeaderSortBg: @table-header-sort-bg;\n  tableBodySortBg: @table-body-sort-bg;\n  tableRowHoverBg: @table-row-hover-bg;\n  tableSelectedRowColor: @table-selected-row-color;\n  tableSelectedRowBg: @table-selected-row-bg;\n  tableBodySelectedSortBg: @table-body-selected-sort-bg;\n  tableSelectedRowHoverBg: @table-selected-row-hover-bg;\n  tableExpandedRowBg: @table-expanded-row-bg;\n  tablePaddingVertical: @table-padding-vertical;\n  tablePaddingHorizontal: @table-padding-horizontal;\n  tablePaddingVerticalMd: @table-padding-vertical-md;\n  tablePaddingHorizontalMd: @table-padding-horizontal-md;\n  tablePaddingVerticalSm: @table-padding-vertical-sm;\n  tablePaddingHorizontalSm: @table-padding-horizontal-sm;\n  tableBorderRadiusBase: @table-border-radius-base;\n  tableFooterBg: @table-footer-bg;\n  tableFooterColor: @table-footer-color;\n  tableHeaderBgSm: @table-header-bg-sm;\n  tableFontSize: @table-font-size;\n  tableFontSizeMd: @table-font-size-md;\n  tableFontSizeSm: @table-font-size-sm;\n  tableHeaderSortActiveBg: @table-header-sort-active-bg;\n  tableHeaderFilterActiveBg: @table-header-filter-active-bg;\n  tableFilterBtnsBg: @table-filter-btns-bg;\n  tableFilterDropdownBg: @table-filter-dropdown-bg;\n  tableExpandIconBg: @table-expand-icon-bg;\n  tableSelectionColumnWidth: @table-selection-column-width;\n  tableStickyScrollBarBg: @table-sticky-scroll-bar-bg;\n  tableStickyScrollBarRadius: @table-sticky-scroll-bar-radius;\n  tagDefaultBg: @tag-default-bg;\n  tagDefaultColor: @tag-default-color;\n  tagFontSize: @tag-font-size;\n  tagLineHeight: @tag-line-height;\n  pickerBg: @picker-bg;\n  pickerBasicCellHoverColor: @picker-basic-cell-hover-color;\n  pickerBasicCellActiveWithRangeColor: @picker-basic-cell-active-with-range-color;\n  pickerBasicCellHoverWithRangeColor: @picker-basic-cell-hover-with-range-color;\n  pickerBasicCellDisabledBg: @picker-basic-cell-disabled-bg;\n  pickerBorderColor: @picker-border-color;\n  pickerDateHoverRangeBorderColor: @picker-date-hover-range-border-color;\n  pickerDateHoverRangeColor: @picker-date-hover-range-color;\n  pickerPanelCellHeight: @picker-panel-cell-height;\n  pickerPanelCellWidth: @picker-panel-cell-width;\n  pickerTextHeight: @picker-text-height;\n  pickerPanelWithoutTimeCellHeight: @picker-panel-without-time-cell-height;\n  calendarBg: @calendar-bg;\n  calendarInputBg: @calendar-input-bg;\n  calendarBorderColor: @calendar-border-color;\n  calendarItemActiveBg: @calendar-item-active-bg;\n  calendarFullBg: @calendar-full-bg;\n  calendarFullPanelBg: @calendar-full-panel-bg;\n  carouselDotWidth: @carousel-dot-width;\n  carouselDotHeight: @carousel-dot-height;\n  carouselDotActiveWidth: @carousel-dot-active-width;\n  badgeHeight: @badge-height;\n  badgeHeightSm: @badge-height-sm;\n  badgeDotSize: @badge-dot-size;\n  badgeFontSize: @badge-font-size;\n  badgeFontSizeSm: @badge-font-size-sm;\n  badgeFontWeight: @badge-font-weight;\n  badgeStatusSize: @badge-status-size;\n  badgeTextColor: @badge-text-color;\n  badgeColor: @badge-color;\n  rateStarColor: @rate-star-color;\n  rateStarBg: @rate-star-bg;\n  rateStarSize: @rate-star-size;\n  rateStarHoverScale: @rate-star-hover-scale;\n  cardHeadColor: @card-head-color;\n  cardHeadBackground: @card-head-background;\n  cardHeadFontSize: @card-head-font-size;\n  cardHeadFontSizeSm: @card-head-font-size-sm;\n  cardHeadPadding: @card-head-padding;\n  cardHeadPaddingSm: @card-head-padding-sm;\n  cardHeadHeight: @card-head-height;\n  cardHeadHeightSm: @card-head-height-sm;\n  cardInnerHeadPadding: @card-inner-head-padding;\n  cardPaddingBase: @card-padding-base;\n  cardPaddingBaseSm: @card-padding-base-sm;\n  cardActionsBackground: @card-actions-background;\n  cardActionsLiMargin: @card-actions-li-margin;\n  cardSkeletonBg: @card-skeleton-bg;\n  cardBackground: @card-background;\n  cardShadow: @card-shadow;\n  cardRadius: @card-radius;\n  cardHeadTabsMarginBottom: @card-head-tabs-margin-bottom;\n  cardHeadExtraColor: @card-head-extra-color;\n  commentBg: @comment-bg;\n  commentPaddingBase: @comment-padding-base;\n  commentNestIndent: @comment-nest-indent;\n  commentFontSizeBase: @comment-font-size-base;\n  commentFontSizeSm: @comment-font-size-sm;\n  commentAuthorNameColor: @comment-author-name-color;\n  commentAuthorTimeColor: @comment-author-time-color;\n  commentActionColor: @comment-action-color;\n  commentActionHoverColor: @comment-action-hover-color;\n  commentActionsMarginBottom: @comment-actions-margin-bottom;\n  commentActionsMarginTop: @comment-actions-margin-top;\n  commentContentDetailPMarginBottom: @comment-content-detail-p-margin-bottom;\n  tabsCardHeadBackground: @tabs-card-head-background;\n  tabsCardHeight: @tabs-card-height;\n  tabsCardActiveColor: @tabs-card-active-color;\n  tabsCardHorizontalPadding: @tabs-card-horizontal-padding;\n  tabsCardHorizontalPaddingSm: @tabs-card-horizontal-padding-sm;\n  tabsCardHorizontalPaddingLg: @tabs-card-horizontal-padding-lg;\n  tabsTitleFontSize: @tabs-title-font-size;\n  tabsTitleFontSizeLg: @tabs-title-font-size-lg;\n  tabsTitleFontSizeSm: @tabs-title-font-size-sm;\n  tabsInkBarColor: @tabs-ink-bar-color;\n  tabsBarMargin: @tabs-bar-margin;\n  tabsHorizontalMargin: @tabs-horizontal-margin;\n  tabsHorizontalMarginRtl: @tabs-horizontal-margin-rtl;\n  tabsHorizontalPadding: @tabs-horizontal-padding;\n  tabsHorizontalPaddingLg: @tabs-horizontal-padding-lg;\n  tabsHorizontalPaddingSm: @tabs-horizontal-padding-sm;\n  tabsVerticalPadding: @tabs-vertical-padding;\n  tabsVerticalMargin: @tabs-vertical-margin;\n  tabsScrollingSize: @tabs-scrolling-size;\n  tabsHighlightColor: @tabs-highlight-color;\n  tabsHoverColor: @tabs-hover-color;\n  tabsActiveColor: @tabs-active-color;\n  tabsCardGutter: @tabs-card-gutter;\n  tabsCardTabActiveBorderTop: @tabs-card-tab-active-border-top;\n  backTopColor: @back-top-color;\n  backTopBg: @back-top-bg;\n  backTopHoverBg: @back-top-hover-bg;\n  avatarSizeBase: @avatar-size-base;\n  avatarSizeLg: @avatar-size-lg;\n  avatarSizeSm: @avatar-size-sm;\n  avatarFontSizeBase: @avatar-font-size-base;\n  avatarFontSizeLg: @avatar-font-size-lg;\n  avatarFontSizeSm: @avatar-font-size-sm;\n  avatarBg: @avatar-bg;\n  avatarColor: @avatar-color;\n  avatarBorderRadius: @avatar-border-radius;\n  avatarGroupOverlapping: @avatar-group-overlapping;\n  avatarGroupSpace: @avatar-group-space;\n  avatarGroupBorderColor: @avatar-group-border-color;\n  switchHeight: @switch-height;\n  switchSmHeight: @switch-sm-height;\n  switchMinWidth: @switch-min-width;\n  switchSmMinWidth: @switch-sm-min-width;\n  switchDisabledOpacity: @switch-disabled-opacity;\n  switchColor: @switch-color;\n  switchBg: @switch-bg;\n  switchShadowColor: @switch-shadow-color;\n  switchPadding: @switch-padding;\n  switchInnerMarginMin: @switch-inner-margin-min;\n  switchInnerMarginMax: @switch-inner-margin-max;\n  switchSmInnerMarginMin: @switch-sm-inner-margin-min;\n  switchSmInnerMarginMax: @switch-sm-inner-margin-max;\n  paginationItemBg: @pagination-item-bg;\n  paginationItemSize: @pagination-item-size;\n  paginationItemSizeSm: @pagination-item-size-sm;\n  paginationFontFamily: @pagination-font-family;\n  paginationFontWeightActive: @pagination-font-weight-active;\n  paginationItemBgActive: @pagination-item-bg-active;\n  paginationItemLinkBg: @pagination-item-link-bg;\n  paginationItemDisabledColorActive: @pagination-item-disabled-color-active;\n  paginationItemDisabledBgActive: @pagination-item-disabled-bg-active;\n  paginationItemInputBg: @pagination-item-input-bg;\n  paginationMiniOptionsSizeChangerTop: @pagination-mini-options-size-changer-top;\n  pageHeaderPadding: @page-header-padding;\n  pageHeaderPaddingVertical: @page-header-padding-vertical;\n  pageHeaderPaddingBreadcrumb: @page-header-padding-breadcrumb;\n  pageHeaderContentPaddingVertical: @page-header-content-padding-vertical;\n  pageHeaderBackColor: @page-header-back-color;\n  pageHeaderGhostBg: @page-header-ghost-bg;\n  pageHeaderHeadingTitle: @page-header-heading-title;\n  pageHeaderHeadingSubTitle: @page-header-heading-sub-title;\n  pageHeaderTabsTabFontSize: @page-header-tabs-tab-font-size;\n  breadcrumbBaseColor: @breadcrumb-base-color;\n  breadcrumbLastItemColor: @breadcrumb-last-item-color;\n  breadcrumbFontSize: @breadcrumb-font-size;\n  breadcrumbIconFontSize: @breadcrumb-icon-font-size;\n  breadcrumbLinkColor: @breadcrumb-link-color;\n  breadcrumbLinkColorHover: @breadcrumb-link-color-hover;\n  breadcrumbSeparatorColor: @breadcrumb-separator-color;\n  breadcrumbSeparatorMargin: @breadcrumb-separator-margin;\n  sliderMargin: @slider-margin;\n  sliderRailBackgroundColor: @slider-rail-background-color;\n  sliderRailBackgroundColorHover: @slider-rail-background-color-hover;\n  sliderTrackBackgroundColor: @slider-track-background-color;\n  sliderTrackBackgroundColorHover: @slider-track-background-color-hover;\n  sliderHandleBorderWidth: @slider-handle-border-width;\n  sliderHandleBackgroundColor: @slider-handle-background-color;\n  sliderHandleColor: @slider-handle-color;\n  sliderHandleColorHover: @slider-handle-color-hover;\n  sliderHandleColorFocus: @slider-handle-color-focus;\n  sliderHandleColorFocusShadow: @slider-handle-color-focus-shadow;\n  sliderHandleColorTooltipOpen: @slider-handle-color-tooltip-open;\n  sliderHandleSize: @slider-handle-size;\n  sliderHandleMarginTop: @slider-handle-margin-top;\n  sliderHandleShadow: @slider-handle-shadow;\n  sliderDotBorderColor: @slider-dot-border-color;\n  sliderDotBorderColorActive: @slider-dot-border-color-active;\n  sliderDisabledColor: @slider-disabled-color;\n  sliderDisabledBackgroundColor: @slider-disabled-background-color;\n  treeBg: @tree-bg;\n  treeTitleHeight: @tree-title-height;\n  treeChildPadding: @tree-child-padding;\n  treeDirectorySelectedColor: @tree-directory-selected-color;\n  treeDirectorySelectedBg: @tree-directory-selected-bg;\n  treeNodeHoverBg: @tree-node-hover-bg;\n  treeNodeSelectedBg: @tree-node-selected-bg;\n  collapseHeaderPadding: @collapse-header-padding;\n  collapseHeaderPaddingExtra: @collapse-header-padding-extra;\n  collapseHeaderBg: @collapse-header-bg;\n  collapseContentPadding: @collapse-content-padding;\n  collapseContentBg: @collapse-content-bg;\n  collapseHeaderArrowLeft: @collapse-header-arrow-left;\n  skeletonColor: @skeleton-color;\n  skeletonToColor: @skeleton-to-color;\n  skeletonParagraphMarginTop: @skeleton-paragraph-margin-top;\n  skeletonParagraphLiMarginTop: @skeleton-paragraph-li-margin-top;\n  skeletonParagraphLiHeight: @skeleton-paragraph-li-height;\n  skeletonTitleHeight: @skeleton-title-height;\n  skeletonTitleParagraphMarginTop: @skeleton-title-paragraph-margin-top;\n  transferHeaderHeight: @transfer-header-height;\n  transferItemHeight: @transfer-item-height;\n  transferDisabledBg: @transfer-disabled-bg;\n  transferListHeight: @transfer-list-height;\n  transferItemHoverBg: @transfer-item-hover-bg;\n  transferItemPaddingVertical: @transfer-item-padding-vertical;\n  transferListSearchIconTop: @transfer-list-search-icon-top;\n  messageNoticeContentPadding: @message-notice-content-padding;\n  messageNoticeContentBg: @message-notice-content-bg;\n  waveAnimationWidth: @wave-animation-width;\n  alertSuccessBorderColor: @alert-success-border-color;\n  alertSuccessBgColor: @alert-success-bg-color;\n  alertSuccessIconColor: @alert-success-icon-color;\n  alertInfoBorderColor: @alert-info-border-color;\n  alertInfoBgColor: @alert-info-bg-color;\n  alertInfoIconColor: @alert-info-icon-color;\n  alertWarningBorderColor: @alert-warning-border-color;\n  alertWarningBgColor: @alert-warning-bg-color;\n  alertWarningIconColor: @alert-warning-icon-color;\n  alertErrorBorderColor: @alert-error-border-color;\n  alertErrorBgColor: @alert-error-bg-color;\n  alertErrorIconColor: @alert-error-icon-color;\n  alertMessageColor: @alert-message-color;\n  alertTextColor: @alert-text-color;\n  alertCloseColor: @alert-close-color;\n  alertCloseHoverColor: @alert-close-hover-color;\n  alertNoIconPaddingVertical: @alert-no-icon-padding-vertical;\n  alertWithDescriptionNoIconPaddingVertical: @alert-with-description-no-icon-padding-vertical;\n  alertWithDescriptionPaddingVertical: @alert-with-description-padding-vertical;\n  alertWithDescriptionPadding: @alert-with-description-padding;\n  alertIconTop: @alert-icon-top;\n  alertWithDescriptionIconSize: @alert-with-description-icon-size;\n  listHeaderBackground: @list-header-background;\n  listFooterBackground: @list-footer-background;\n  listEmptyTextPadding: @list-empty-text-padding;\n  listItemPadding: @list-item-padding;\n  listItemPaddingSm: @list-item-padding-sm;\n  listItemPaddingLg: @list-item-padding-lg;\n  listItemMetaMarginBottom: @list-item-meta-margin-bottom;\n  listItemMetaAvatarMarginRight: @list-item-meta-avatar-margin-right;\n  listItemMetaTitleMarginBottom: @list-item-meta-title-margin-bottom;\n  listCustomizeCardBg: @list-customize-card-bg;\n  listItemMetaDescriptionFontSize: @list-item-meta-description-font-size;\n  statisticTitleFontSize: @statistic-title-font-size;\n  statisticContentFontSize: @statistic-content-font-size;\n  statisticUnitFontSize: @statistic-unit-font-size;\n  statisticFontFamily: @statistic-font-family;\n  drawerHeaderPadding: @drawer-header-padding;\n  drawerBodyPadding: @drawer-body-padding;\n  drawerBg: @drawer-bg;\n  drawerFooterPaddingVertical: @drawer-footer-padding-vertical;\n  drawerFooterPaddingHorizontal: @drawer-footer-padding-horizontal;\n  drawerHeaderCloseSize: @drawer-header-close-size;\n  timelineWidth: @timeline-width;\n  timelineColor: @timeline-color;\n  timelineDotBorderWidth: @timeline-dot-border-width;\n  timelineDotColor: @timeline-dot-color;\n  timelineDotBg: @timeline-dot-bg;\n  timelineItemPaddingBottom: @timeline-item-padding-bottom;\n  typographyTitleFontWeight: @typography-title-font-weight;\n  typographyTitleMarginTop: @typography-title-margin-top;\n  typographyTitleMarginBottom: @typography-title-margin-bottom;\n  uploadActionsColor: @upload-actions-color;\n  processTailColor: @process-tail-color;\n  stepsNavArrowColor: @steps-nav-arrow-color;\n  stepsBackground: @steps-background;\n  stepsIconSize: @steps-icon-size;\n  stepsIconCustomSize: @steps-icon-custom-size;\n  stepsIconCustomTop: @steps-icon-custom-top;\n  stepsIconCustomFontSize: @steps-icon-custom-font-size;\n  stepsIconTop: @steps-icon-top;\n  stepsIconFontSize: @steps-icon-font-size;\n  stepsIconMargin: @steps-icon-margin;\n  stepsTitleLineHeight: @steps-title-line-height;\n  stepsSmallIconSize: @steps-small-icon-size;\n  stepsSmallIconMargin: @steps-small-icon-margin;\n  stepsDotSize: @steps-dot-size;\n  stepsDotTop: @steps-dot-top;\n  stepsCurrentDotSize: @steps-current-dot-size;\n  stepsNavContentMaxWidth: @steps-nav-content-max-width;\n  stepsVerticalIconWidth: @steps-vertical-icon-width;\n  stepsVerticalTailWidth: @steps-vertical-tail-width;\n  stepsVerticalTailWidthSm: @steps-vertical-tail-width-sm;\n  notificationBg: @notification-bg;\n  notificationPaddingVertical: @notification-padding-vertical;\n  notificationPaddingHorizontal: @notification-padding-horizontal;\n  resultTitleFontSize: @result-title-font-size;\n  resultSubtitleFontSize: @result-subtitle-font-size;\n  resultIconFontSize: @result-icon-font-size;\n  resultExtraMargin: @result-extra-margin;\n  imageSizeBase: @image-size-base;\n  imageFontSizeBase: @image-font-size-base;\n  imageBg: @image-bg;\n  imageColor: @image-color;\n  imagePreviewOperationSize: @image-preview-operation-size;\n  imagePreviewOperationColor: @image-preview-operation-color;\n  imagePreviewOperationDisabledColor: @image-preview-operation-disabled-color;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxShadowColor": "rgba(0, 0, 0, 0.15)",
	"boxShadowHorLength": "0",
	"boxShadowVerLength": "4",
	"boxShadowBlur": "12",
	"boxShadowSpread": "0",
	"iconSize": "18px",
	"pageBlurRadius": "1.5px",
	"grayBase": "#bfbfbf",
	"gray1": "#ffffff",
	"gray2": "#fafafa",
	"gray3": "#f5f5f5",
	"gray4": "#e8e8e8",
	"gray5": "#d9d9d9",
	"gray6": "#bfbfbf",
	"gray7": "#8c8c8c",
	"gray8": "#595959",
	"gray9": "#262626",
	"gray10": "#000000",
	"alpha45": "rgba(0, 0, 0, 0.45)",
	"alpha85": "rgba(0, 0, 0, 0.85)",
	"blueBase": "#2C6EF2",
	"blue1": "#e8f0ff",
	"blue2": "#d0e0fe",
	"blue3": "#b9d1fe",
	"blue4": "#8ab2fd",
	"blue5": "#5c93fd",
	"blue6": "#2C6EF2",
	"blue7": "#1558da",
	"blue8": "#1346a8",
	"blue9": "#103680",
	"blue10": "#0c2960",
	"purpleBase": "#722ed1",
	"purple1": "#f9f0ff",
	"purple2": "#efdbff",
	"purple3": "#d3adf7",
	"purple4": "#b37feb",
	"purple5": "#9254de",
	"purple6": "#722ed1",
	"purple7": "#531dab",
	"purple8": "#391085",
	"purple9": "#22075e",
	"purple10": "#120338",
	"cyanBase": "#13c2c2",
	"cyan1": "#e6fffb",
	"cyan2": "#b5f5ec",
	"cyan3": "#87e8de",
	"cyan4": "#5cdbd3",
	"cyan5": "#36cfc9",
	"cyan6": "#13c2c2",
	"cyan7": "#08979c",
	"cyan8": "#006d75",
	"cyan9": "#00474f",
	"cyan10": "#002329",
	"greenBase": "#30d184",
	"green1": "#eafaf3",
	"green2": "#d6f6e6",
	"green3": "#acedce",
	"green4": "#83e4b5",
	"green5": "#59da9d",
	"green6": "#30d184",
	"green7": "#27ba73",
	"green8": "#199459",
	"green9": "#136e43",
	"green10": "#0a4127",
	"magentaBase": "#eb2f96",
	"magenta1": "#fff0f6",
	"magenta2": "#ffd6e7",
	"magenta3": "#ffadd2",
	"magenta4": "#ff85c0",
	"magenta5": "#f759ab",
	"magenta6": "#eb2f96",
	"magenta7": "#c41d7f",
	"magenta8": "#9e1068",
	"magenta9": "#780650",
	"magenta10": "#520339",
	"pinkBase": "#eb2f96",
	"pink1": "#fff0f6",
	"pink2": "#ffd6e7",
	"pink3": "#ffadd2",
	"pink4": "#ff85c0",
	"pink5": "#f759ab",
	"pink6": "#eb2f96",
	"pink7": "#c41d7f",
	"pink8": "#9e1068",
	"pink9": "#780650",
	"pink10": "#520339",
	"redBase": "#f5222d",
	"red1": "#fff1f0",
	"red2": "#ffccc7",
	"red3": "#ffa39e",
	"red4": "#ff7875",
	"red5": "#ff4d4f",
	"red6": "#f5222d",
	"red7": "#cf1322",
	"red8": "#a8071a",
	"red9": "#820014",
	"red10": "#5c0011",
	"orangeBase": "#fa8c16",
	"orange1": "#fff7e6",
	"orange2": "#ffe7ba",
	"orange3": "#ffd591",
	"orange4": "#ffc069",
	"orange5": "#ffa940",
	"orange6": "#fa8c16",
	"orange7": "#d46b08",
	"orange8": "#ad4e00",
	"orange9": "#873800",
	"orange10": "#612500",
	"yellowBase": "#fadb14",
	"yellow1": "#feffe6",
	"yellow2": "#ffffb8",
	"yellow3": "#fffb8f",
	"yellow4": "#fff566",
	"yellow5": "#ffec3d",
	"yellow6": "#fadb14",
	"yellow7": "#d4b106",
	"yellow8": "#ad8b00",
	"yellow9": "#876800",
	"yellow10": "#614700",
	"volcanoBase": "#fa541c",
	"volcano1": "#fff2e8",
	"volcano2": "#ffd8bf",
	"volcano3": "#ffbb96",
	"volcano4": "#ff9c6e",
	"volcano5": "#ff7a45",
	"volcano6": "#fa541c",
	"volcano7": "#d4380d",
	"volcano8": "#ad2102",
	"volcano9": "#871400",
	"volcano10": "#610b00",
	"geekblueBase": "#2f54eb",
	"geekblue1": "#f0f5ff",
	"geekblue2": "#d6e4ff",
	"geekblue3": "#adc6ff",
	"geekblue4": "#85a5ff",
	"geekblue5": "#597ef7",
	"geekblue6": "#2f54eb",
	"geekblue7": "#1d39c4",
	"geekblue8": "#10239e",
	"geekblue9": "#061178",
	"geekblue10": "#030852",
	"limeBase": "#a0d911",
	"lime1": "#fcffe6",
	"lime2": "#f4ffb8",
	"lime3": "#eaff8f",
	"lime4": "#d3f261",
	"lime5": "#bae637",
	"lime6": "#a0d911",
	"lime7": "#7cb305",
	"lime8": "#5b8c00",
	"lime9": "#3f6600",
	"lime10": "#254000",
	"goldBase": "#faad14",
	"gold1": "#fffbe6",
	"gold2": "#fff1b8",
	"gold3": "#ffe58f",
	"gold4": "#ffd666",
	"gold5": "#ffc53d",
	"gold6": "#faad14",
	"gold7": "#d48806",
	"gold8": "#ad6800",
	"gold9": "#874d00",
	"gold10": "#613400",
	"neutralBase": "#bfbfbf",
	"neutral1": "#ffffff",
	"neutral2": "#fafafa",
	"neutral3": "#f5f5f5",
	"neutral4": "#f0f0f0",
	"neutral5": "#d9d9d9",
	"neutral6": "#bfbfbf",
	"neutral7": "#8c8c8c",
	"neutral8": "#595959",
	"neutral9": "#434343",
	"neutral10": "#262626",
	"presetColors": "pink, magenta, red, volcano, orange, yellow, gold, cyan, lime, green, blue, geekblue, purple",
	"primaryColor": "#2C6EF2",
	"infoColor": "#2C6EF2",
	"successColor": "#30d184",
	"processingColor": "#2C6EF2",
	"errorColor": "#ff4d4f",
	"highlightColor": "#ff4d4f",
	"warningColor": "#fadb14",
	"normalColor": "#d9d9d9",
	"white": "#fff",
	"black": "#000",
	"primary1": "#e8f0ff",
	"primary2": "#d0e0fe",
	"primary3": "#b9d1fe",
	"primary4": "#8ab2fd",
	"primary5": "#5c93fd",
	"primary6": "#2C6EF2",
	"primary7": "#1558da",
	"primary8": "#1346a8",
	"primary9": "#103680",
	"primary10": "#0c2960",
	"bodyBackground": "#fff",
	"componentBackground": "#fff",
	"popoverBackground": "#fff",
	"popoverCustomizeBorderColor": "#f0f0f0",
	"fontFamily": "inter, 'Helvetica Neue', Arial, sans-serif",
	"codeFamily": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
	"textColor": "#262626",
	"textColorSecondary": "#8c8c8c",
	"textColorInverse": "#fff",
	"iconColor": "#8c8c8c",
	"iconColorHover": "rgba(0, 0, 0, 0.75)",
	"headingColor": "rgba(0, 0, 0, 0.85)",
	"textColorDark": "rgba(255, 255, 255, 0.85)",
	"textColorSecondaryDark": "rgba(255, 255, 255, 0.65)",
	"textSelectionBg": "#2C6EF2",
	"fontVariantBase": "tabular-nums",
	"fontFeatureSettingsBase": "'tnum'",
	"fontSizeBase": "14px",
	"fontSizeLg": "16px",
	"fontSizeSm": "12px",
	"heading1Size": "24px",
	"heading2Size": "20px",
	"heading3Size": "16px",
	"heading4Size": "14px",
	"heading5Size": "12px",
	"lineHeightBase": "1.5715",
	"borderRadiusBase": "4px",
	"borderRadiusSm": "2px",
	"paddingLg": "24px",
	"paddingMd": "16px",
	"paddingSm": "12px",
	"paddingXs": "8px",
	"paddingXss": "4px",
	"controlPaddingHorizontal": "12px",
	"controlPaddingHorizontalSm": "8px",
	"marginLg": "24px",
	"marginMd": "16px",
	"marginSm": "12px",
	"marginXs": "8px",
	"marginXss": "4px",
	"heightBase": "32px",
	"heightLg": "40px",
	"heightSm": "24px",
	"itemActiveBg": "#e8f0ff",
	"itemHoverBg": "#f5f5f5",
	"iconfontCssPrefix": "anticon",
	"linkColor": "#2C6EF2",
	"linkHoverColor": "#5794ff",
	"linkActiveColor": "#1b50cc",
	"linkDecoration": "none",
	"linkHoverDecoration": "none",
	"linkFocusDecoration": "none",
	"linkFocusOutline": "0",
	"easeBaseOut": "cubic-bezier(0.7, 0.3, 0.1, 1)",
	"easeBaseIn": "cubic-bezier(0.9, 0, 0.3, 0.7)",
	"easeOut": "cubic-bezier(0.215, 0.61, 0.355, 1)",
	"easeIn": "cubic-bezier(0.55, 0.055, 0.675, 0.19)",
	"easeInOut": "cubic-bezier(0.645, 0.045, 0.355, 1)",
	"easeOutBack": "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
	"easeInBack": "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
	"easeInOutBack": "cubic-bezier(0.71, -0.46, 0.29, 1.46)",
	"easeOutCirc": "cubic-bezier(0.08, 0.82, 0.17, 1)",
	"easeInCirc": "cubic-bezier(0.6, 0.04, 0.98, 0.34)",
	"easeInOutCirc": "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
	"easeOutQuint": "cubic-bezier(0.23, 1, 0.32, 1)",
	"easeInQuint": "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
	"easeInOutQuint": "cubic-bezier(0.86, 0, 0.07, 1)",
	"borderColorBase": "#d9d9d9",
	"borderColorSplit": "#f0f0f0",
	"borderColorInverse": "#fff",
	"borderWidthBase": "1px",
	"borderStyleBase": "solid",
	"outlineBlurSize": "0",
	"outlineWidth": "2px",
	"outlineColor": "#2C6EF2",
	"outlineFade": "20%",
	"backgroundColorLight": "#fafafa",
	"backgroundColorBase": "#f5f5f5",
	"disabledColor": "rgba(0, 0, 0, 0.25)",
	"disabledBg": "#f5f5f5",
	"disabledColorDark": "rgba(255, 255, 255, 0.35)",
	"shadowColor": "rgba(0, 0, 0, 0.15)",
	"shadowColorInverse": "#fff",
	"boxShadowBase": "0px 4px 12px 0px rgba(0, 0, 0, 0.15)",
	"shadow1Up": "0 -6px 16px -8px rgba(0, 0, 0, 0.08), 0 -9px 28px 0 rgba(0, 0, 0, 0.05), 0 -12px 48px 16px rgba(0, 0, 0, 0.03)",
	"shadow1Down": "0 6px 16px -8px rgba(0, 0, 0, 0.08), 0 9px 28px 0 rgba(0, 0, 0, 0.05), 0 12px 48px 16px rgba(0, 0, 0, 0.03)",
	"shadow1Left": "-6px 0 16px -8px rgba(0, 0, 0, 0.08), -9px 0 28px 0 rgba(0, 0, 0, 0.05), -12px 0 48px 16px rgba(0, 0, 0, 0.03)",
	"shadow1Right": "6px 0 16px -8px rgba(0, 0, 0, 0.08), 9px 0 28px 0 rgba(0, 0, 0, 0.05), 12px 0 48px 16px rgba(0, 0, 0, 0.03)",
	"shadow2": "0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
	"btnFontWeight": "400",
	"btnBorderRadiusBase": "4px",
	"btnBorderRadiusSm": "4px",
	"btnBorderWidth": "1px",
	"btnBorderStyle": "solid",
	"btnShadow": "0 2px 0 rgba(0, 0, 0, 0.015)",
	"btnPrimaryShadow": "0 2px 0 rgba(0, 0, 0, 0.045)",
	"btnTextShadow": "0 -1px 0 rgba(0, 0, 0, 0.12)",
	"btnPrimaryColor": "#fff",
	"btnPrimaryBg": "#2C6EF2",
	"btnDefaultColor": "#595959",
	"btnDefaultBg": "#fff",
	"btnDefaultBorder": "#d9d9d9",
	"btnDangerColor": "#fff",
	"btnDangerBg": "#ff4d4f",
	"btnDangerBorder": "#ff4d4f",
	"btnDisableColor": "rgba(0, 0, 0, 0.25)",
	"btnDisableBg": "#f5f5f5",
	"btnDisableBorder": "#d9d9d9",
	"btnDefaultGhostColor": "#fff",
	"btnDefaultGhostBg": "transparent",
	"btnDefaultGhostBorder": "#fff",
	"btnFontSizeLg": "16px",
	"btnFontSizeSm": "14px",
	"btnPaddingHorizontalBase": "15px",
	"btnPaddingHorizontalLg": "15px",
	"btnPaddingHorizontalSm": "7px",
	"btnHeightBase": "32px",
	"btnHeightLg": "40px",
	"btnHeightSm": "24px",
	"btnLineHeight": "1.5715",
	"btnCircleSize": "32px",
	"btnCircleSizeLg": "40px",
	"btnCircleSizeSm": "24px",
	"btnSquareSize": "32px",
	"btnSquareSizeLg": "40px",
	"btnSquareSizeSm": "24px",
	"btnSquareOnlyIconSize": "16px",
	"btnSquareOnlyIconSizeSm": "14px",
	"btnSquareOnlyIconSizeLg": "18px",
	"btnGroupBorder": "#5c93fd",
	"btnLinkHoverBg": "transparent",
	"btnTextHoverBg": "#f5f5f5",
	"checkboxSize": "16px",
	"checkboxColor": "#2C6EF2",
	"checkboxCheckColor": "#fff",
	"checkboxCheckBg": "#fff",
	"checkboxBorderWidth": "1px",
	"checkboxGroupItemMarginRight": "8px",
	"descriptionsBg": "#fafafa",
	"descriptionsTitleMarginBottom": "20px",
	"descriptionsDefaultPadding": "16px 24px",
	"descriptionsMiddlePadding": "12px 24px",
	"descriptionsSmallPadding": "8px 16px",
	"descriptionsItemPaddingBottom": "16px",
	"descriptionsItemTrailingColon": "true",
	"descriptionsItemLabelColonMarginRight": "8px",
	"descriptionsItemLabelColonMarginLeft": "2px",
	"descriptionsExtraColor": "#262626",
	"dividerTextPadding": "1em",
	"dividerOrientationMargin": "5%",
	"dividerColor": "rgba(0, 0, 0, 0.06)",
	"dropdownSelectedColor": "#2C6EF2",
	"dropdownMenuSubmenuDisabledBg": "#fff",
	"emptyFontSize": "14px",
	"radioSize": "16px",
	"radioTop": "0.2em",
	"radioDotColor": "#2C6EF2",
	"radioDotDisabledColor": "rgba(0, 0, 0, 0.2)",
	"radioSolidCheckedColor": "#fff",
	"radioButtonBg": "#fff",
	"radioButtonCheckedBg": "#fff",
	"radioButtonColor": "#595959",
	"radioButtonHoverColor": "#5c93fd",
	"radioButtonActiveColor": "#1558da",
	"radioDisabledButtonCheckedBg": "#e6e6e6",
	"radioDisabledButtonCheckedColor": "rgba(0, 0, 0, 0.25)",
	"radioWrapperMarginRight": "8px",
	"screenXs": "480px",
	"screenXsMin": "480px",
	"screenSm": "576px",
	"screenSmMin": "576px",
	"screenMd": "768px",
	"screenMdMin": "768px",
	"screenLg": "992px",
	"screenLgMin": "992px",
	"screenXl": "1200px",
	"screenXlMin": "1200px",
	"screenXxl": "1600px",
	"screenXxlMin": "1600px",
	"screenXsMax": "575px",
	"screenSmMax": "767px",
	"screenMdMax": "991px",
	"screenLgMax": "1199px",
	"screenXlMax": "1599px",
	"gridColumns": "24",
	"layoutBodyBackground": "#f0f2f5",
	"layoutHeaderBackground": "#001529",
	"layoutHeaderHeight": "64px",
	"layoutHeaderPadding": "0 50px",
	"layoutHeaderColor": "#262626",
	"layoutFooterPadding": "24px 50px",
	"layoutFooterBackground": "#f0f2f5",
	"layoutSiderBackground": "#fafafa",
	"layoutTriggerHeight": "48px",
	"layoutTriggerBackground": "transparent",
	"layoutTriggerColor": "#fff",
	"layoutZeroTriggerWidth": "0px",
	"layoutZeroTriggerHeight": "0px",
	"layoutSiderBackgroundLight": "#fff",
	"layoutTriggerBackgroundLight": "#fff",
	"layoutTriggerColorLight": "#262626",
	"zindexBadge": "auto",
	"zindexTableFixed": "2",
	"zindexAffix": "10",
	"zindexBackTop": "10",
	"zindexPickerPanel": "10",
	"zindexPopupClose": "10",
	"zindexModal": "1000",
	"zindexModalMask": "1000",
	"zindexMessage": "5000",
	"zindexNotification": "1010",
	"zindexPopover": "1030",
	"zindexDropdown": "1050",
	"zindexPicker": "1050",
	"zindexPopoconfirm": "1060",
	"zindexTooltip": "1070",
	"zindexImage": "1080",
	"animationDurationSlow": "0.3s",
	"animationDurationBase": "0.2s",
	"animationDurationFast": "0.1s",
	"collapsePanelBorderRadius": "4px",
	"dropdownMenuBg": "#fff",
	"dropdownVerticalPadding": "5px",
	"dropdownEdgeChildVerticalPadding": "0",
	"dropdownFontSize": "14px",
	"dropdownLineHeight": "22px",
	"labelRequiredColor": "#ff4d4f",
	"labelColor": "rgba(0, 0, 0, 0.85)",
	"formWarningInputBg": "#f5f5f5",
	"formItemMarginBottom": "24px",
	"formItemTrailingColon": "true",
	"formVerticalLabelPadding": "0 0 8px",
	"formVerticalLabelMargin": "0",
	"formItemLabelFontSize": "14px",
	"formItemLabelHeight": "32px",
	"formItemLabelColonMarginRight": "8px",
	"formItemLabelColonMarginLeft": "2px",
	"formErrorInputBg": "#f5f5f5",
	"inputHeightBase": "32px",
	"inputHeightLg": "40px",
	"inputHeightSm": "24px",
	"inputPaddingHorizontal": "11px",
	"inputPaddingHorizontalBase": "11px",
	"inputPaddingHorizontalSm": "7px",
	"inputPaddingHorizontalLg": "11px",
	"inputPaddingVerticalBase": "4px",
	"inputPaddingVerticalSm": "0px",
	"inputPaddingVerticalLg": "6.5px",
	"inputPlaceholderColor": "#bfbfbf",
	"inputColor": "#262626",
	"inputIconColor": "#262626",
	"inputBorderColor": "transparent",
	"inputBg": "#f5f5f5",
	"inputNumberHoverBorderColor": "#5c93fd",
	"inputNumberHandlerActiveBg": "#f4f4f4",
	"inputNumberHandlerHoverBg": "#5c93fd",
	"inputNumberHandlerBg": "#fff",
	"inputNumberHandlerBorderColor": "#d9d9d9",
	"inputAddonBg": "#fafafa",
	"inputHoverBorderColor": "#5c93fd",
	"inputDisabledBg": "#f5f5f5",
	"inputOutlineOffset": "0 0",
	"inputIconHoverColor": "rgba(0, 0, 0, 0.85)",
	"inputDisabledColor": "rgba(0, 0, 0, 0.25)",
	"mentionsDropdownBg": "#fff",
	"mentionsDropdownMenuItemHoverBg": "#fff",
	"selectBorderColor": "transparent",
	"selectItemSelectedColor": "#262626",
	"selectItemSelectedFontWeight": "600",
	"selectDropdownBg": "#fff",
	"selectItemSelectedBg": "#e8f0ff",
	"selectItemActiveBg": "#f5f5f5",
	"selectDropdownVerticalPadding": "5px",
	"selectDropdownFontSize": "14px",
	"selectDropdownLineHeight": "22px",
	"selectDropdownHeight": "32px",
	"selectBackground": "#f5f5f5",
	"selectClearBackground": "#f5f5f5",
	"selectSelectionItemBg": "#f5f5f5",
	"selectSelectionItemBorderColor": "#f0f0f0",
	"selectSingleItemHeightLg": "40px",
	"selectMultipleItemHeight": "24px",
	"selectMultipleItemHeightLg": "32px",
	"selectMultipleItemSpacingHalf": "2px",
	"selectMultipleDisabledBackground": "#f5f5f5",
	"selectMultipleItemDisabledColor": "#bfbfbf",
	"selectMultipleItemDisabledBorderColor": "transparent",
	"cascaderBg": "#fff",
	"cascaderItemSelectedBg": "#e8f0ff",
	"cascaderMenuBg": "#fff",
	"cascaderMenuBorderColorSplit": "#f0f0f0",
	"cascaderDropdownVerticalPadding": "5px",
	"cascaderDropdownEdgeChildVerticalPadding": "0",
	"cascaderDropdownFontSize": "14px",
	"cascaderDropdownLineHeight": "22px",
	"anchorBg": "transparent",
	"anchorBorderColor": "#f0f0f0",
	"anchorLinkTop": "4px",
	"anchorLinkLeft": "16px",
	"anchorLinkPadding": "4px 0 4px 16px",
	"tooltipMaxWidth": "250px",
	"tooltipColor": "#fff",
	"tooltipBg": "rgba(0, 0, 0, 0.75)",
	"tooltipArrowWidth": "11.3137085px",
	"tooltipDistance": "14.3137085px",
	"tooltipArrowColor": "rgba(0, 0, 0, 0.75)",
	"popoverBg": "#fff",
	"popoverColor": "#262626",
	"popoverMinWidth": "177px",
	"popoverMinHeight": "32px",
	"popoverArrowWidth": "11.3137085px",
	"popoverArrowColor": "#fff",
	"popoverArrowOuterColor": "#fff",
	"popoverDistance": "15.3137085px",
	"popoverPaddingHorizontal": "16px",
	"modalHeaderPaddingVertical": "16px",
	"modalHeaderPaddingHorizontal": "24px",
	"modalBodyPadding": "24px",
	"modalHeaderBg": "#fff",
	"modalHeaderPadding": "16px 24px",
	"modalHeaderBorderWidth": "1px",
	"modalHeaderBorderStyle": "solid",
	"modalHeaderTitleLineHeight": "22px",
	"modalHeaderTitleFontSize": "16px",
	"modalHeaderBorderColorSplit": "#f0f0f0",
	"modalHeaderCloseSize": "54px",
	"modalContentBg": "#fff",
	"modalHeadingColor": "rgba(0, 0, 0, 0.85)",
	"modalCloseColor": "#8c8c8c",
	"modalFooterBg": "transparent",
	"modalFooterBorderColorSplit": "#f0f0f0",
	"modalFooterBorderStyle": "solid",
	"modalFooterPaddingVertical": "10px",
	"modalFooterPaddingHorizontal": "16px",
	"modalFooterBorderWidth": "1px",
	"modalMaskBg": "rgba(0, 0, 0, 0.45)",
	"modalConfirmBodyPadding": "32px 32px 24px",
	"progressDefaultColor": "#2C6EF2",
	"progressRemainingColor": "#f5f5f5",
	"progressTextColor": "#262626",
	"progressRadius": "100px",
	"progressStepsItemBg": "#f3f3f3",
	"progressTextFontSize": "1em",
	"progressCircleTextFontSize": "1em",
	"menuInlineToplevelItemHeight": "40px",
	"menuItemHeight": "40px",
	"menuItemGroupHeight": "1.5715",
	"menuCollapsedWidth": "80px",
	"menuBg": "#fff",
	"menuPopupBg": "#fff",
	"menuItemColor": "#8c8c8c",
	"menuHighlightColor": "#2C6EF2",
	"menuHighlightDangerColor": "#ff4d4f",
	"menuItemActiveBg": "#e8f0ff",
	"menuItemActiveDangerBg": "#fff1f0",
	"menuItemActiveBorderWidth": "3px",
	"menuItemGroupTitleColor": "#8c8c8c",
	"menuItemVerticalMargin": "4px",
	"menuItemFontSize": "14px",
	"menuItemBoundaryMargin": "8px",
	"menuItemPadding": "0 20px",
	"menuHorizontalLineHeight": "46px",
	"menuIconMarginRight": "10px",
	"menuIconSize": "18px",
	"menuIconSizeLg": "16px",
	"menuItemGroupTitleFontSize": "14px",
	"menuDarkColor": "rgba(255, 255, 255, 0.65)",
	"menuDarkDangerColor": "#ff4d4f",
	"menuDarkBg": "#001529",
	"menuDarkArrowColor": "#fff",
	"menuDarkHighlightColor": "#fff",
	"menuDarkItemActiveBg": "#2C6EF2",
	"menuDarkItemActiveDangerBg": "#ff4d4f",
	"menuDarkSelectedItemIconColor": "#fff",
	"menuDarkSelectedItemTextColor": "#fff",
	"menuDarkItemHoverBg": "transparent",
	"spinDotSizeSm": "14px",
	"spinDotSize": "20px",
	"spinDotSizeLg": "32px",
	"tableBg": "#fff",
	"tableHeaderBg": "#fafafa",
	"tableHeaderColor": "rgba(0, 0, 0, 0.85)",
	"tableHeaderSortBg": "#f5f5f5",
	"tableBodySortBg": "#fafafa",
	"tableRowHoverBg": "#fafafa",
	"tableSelectedRowColor": "inherit",
	"tableSelectedRowBg": "#e8f0ff",
	"tableBodySelectedSortBg": "#e8f0ff",
	"tableSelectedRowHoverBg": "#dee9ff",
	"tableExpandedRowBg": "#fbfbfb",
	"tablePaddingVertical": "16px",
	"tablePaddingHorizontal": "16px",
	"tablePaddingVerticalMd": "12px",
	"tablePaddingHorizontalMd": "8px",
	"tablePaddingVerticalSm": "8px",
	"tablePaddingHorizontalSm": "8px",
	"tableBorderRadiusBase": "4px",
	"tableFooterBg": "white",
	"tableFooterColor": "rgba(0, 0, 0, 0.85)",
	"tableHeaderBgSm": "#fafafa",
	"tableFontSize": "14px",
	"tableFontSizeMd": "14px",
	"tableFontSizeSm": "14px",
	"tableHeaderSortActiveBg": "rgba(0, 0, 0, 0.04)",
	"tableHeaderFilterActiveBg": "rgba(0, 0, 0, 0.04)",
	"tableFilterBtnsBg": "inherit",
	"tableFilterDropdownBg": "#fff",
	"tableExpandIconBg": "#fff",
	"tableSelectionColumnWidth": "32px",
	"tableStickyScrollBarBg": "rgba(0, 0, 0, 0.35)",
	"tableStickyScrollBarRadius": "4px",
	"tagDefaultBg": "#fafafa",
	"tagDefaultColor": "#262626",
	"tagFontSize": "12px",
	"tagLineHeight": "20px",
	"pickerBg": "#fff",
	"pickerBasicCellHoverColor": "#f5f5f5",
	"pickerBasicCellActiveWithRangeColor": "#e8f0ff",
	"pickerBasicCellHoverWithRangeColor": "#d4e2fc",
	"pickerBasicCellDisabledBg": "rgba(0, 0, 0, 0.04)",
	"pickerBorderColor": "#f0f0f0",
	"pickerDateHoverRangeBorderColor": "#8cb0f8",
	"pickerDateHoverRangeColor": "#d4e2fc",
	"pickerPanelCellHeight": "24px",
	"pickerPanelCellWidth": "36px",
	"pickerTextHeight": "40px",
	"pickerPanelWithoutTimeCellHeight": "66px",
	"calendarBg": "#fff",
	"calendarInputBg": "#f5f5f5",
	"calendarBorderColor": "#fff",
	"calendarItemActiveBg": "#e8f0ff",
	"calendarFullBg": "#fff",
	"calendarFullPanelBg": "#fff",
	"carouselDotWidth": "16px",
	"carouselDotHeight": "3px",
	"carouselDotActiveWidth": "24px",
	"badgeHeight": "20px",
	"badgeHeightSm": "14px",
	"badgeDotSize": "6px",
	"badgeFontSize": "12px",
	"badgeFontSizeSm": "12px",
	"badgeFontWeight": "normal",
	"badgeStatusSize": "6px",
	"badgeTextColor": "#fff",
	"badgeColor": "#ff4d4f",
	"rateStarColor": "#fadb14",
	"rateStarBg": "#f0f0f0",
	"rateStarSize": "20px",
	"rateStarHoverScale": "scale(1.1)",
	"cardHeadColor": "rgba(0, 0, 0, 0.85)",
	"cardHeadBackground": "transparent",
	"cardHeadFontSize": "16px",
	"cardHeadFontSizeSm": "14px",
	"cardHeadPadding": "16px",
	"cardHeadPaddingSm": "8px",
	"cardHeadHeight": "48px",
	"cardHeadHeightSm": "36px",
	"cardInnerHeadPadding": "12px",
	"cardPaddingBase": "24px",
	"cardPaddingBaseSm": "12px",
	"cardActionsBackground": "#fff",
	"cardActionsLiMargin": "12px 0",
	"cardSkeletonBg": "#cfd8dc",
	"cardBackground": "#fff",
	"cardShadow": "0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09)",
	"cardRadius": "4px",
	"cardHeadTabsMarginBottom": "-17px",
	"cardHeadExtraColor": "#262626",
	"commentBg": "inherit",
	"commentPaddingBase": "16px 0",
	"commentNestIndent": "44px",
	"commentFontSizeBase": "14px",
	"commentFontSizeSm": "12px",
	"commentAuthorNameColor": "#8c8c8c",
	"commentAuthorTimeColor": "#ccc",
	"commentActionColor": "#8c8c8c",
	"commentActionHoverColor": "#595959",
	"commentActionsMarginBottom": "inherit",
	"commentActionsMarginTop": "12px",
	"commentContentDetailPMarginBottom": "inherit",
	"tabsCardHeadBackground": "#fafafa",
	"tabsCardHeight": "40px",
	"tabsCardActiveColor": "#2C6EF2",
	"tabsCardHorizontalPadding": "8px 16px",
	"tabsCardHorizontalPaddingSm": "6px 16px",
	"tabsCardHorizontalPaddingLg": "7px 16px 6px",
	"tabsTitleFontSize": "14px",
	"tabsTitleFontSizeLg": "16px",
	"tabsTitleFontSizeSm": "14px",
	"tabsInkBarColor": "#2C6EF2",
	"tabsBarMargin": "0 0 16px 0",
	"tabsHorizontalMargin": "0 0 0 32px",
	"tabsHorizontalMarginRtl": "0 0 0 32px",
	"tabsHorizontalPadding": "12px 0",
	"tabsHorizontalPaddingLg": "16px 0",
	"tabsHorizontalPaddingSm": "8px 0",
	"tabsVerticalPadding": "8px 24px",
	"tabsVerticalMargin": "16px 0 0 0",
	"tabsScrollingSize": "32px",
	"tabsHighlightColor": "#262626",
	"tabsHoverColor": "#5c93fd",
	"tabsActiveColor": "#1558da",
	"tabsCardGutter": "2px",
	"tabsCardTabActiveBorderTop": "2px solid transparent",
	"backTopColor": "#fff",
	"backTopBg": "#8c8c8c",
	"backTopHoverBg": "#262626",
	"avatarSizeBase": "32px",
	"avatarSizeLg": "40px",
	"avatarSizeSm": "24px",
	"avatarFontSizeBase": "18px",
	"avatarFontSizeLg": "24px",
	"avatarFontSizeSm": "14px",
	"avatarBg": "#e8f0ff",
	"avatarColor": "#2C6EF2",
	"avatarBorderRadius": "4px",
	"avatarGroupOverlapping": "-8px",
	"avatarGroupSpace": "3px",
	"avatarGroupBorderColor": "#fff",
	"switchHeight": "22px",
	"switchSmHeight": "16px",
	"switchMinWidth": "44px",
	"switchSmMinWidth": "28px",
	"switchDisabledOpacity": "0.4",
	"switchColor": "#2C6EF2",
	"switchBg": "#fff",
	"switchShadowColor": "rgba(0, 35, 11, 0.2)",
	"switchPadding": "2px",
	"switchInnerMarginMin": "7px",
	"switchInnerMarginMax": "25px",
	"switchSmInnerMarginMin": "5px",
	"switchSmInnerMarginMax": "18px",
	"paginationItemBg": "#fff",
	"paginationItemSize": "32px",
	"paginationItemSizeSm": "24px",
	"paginationFontFamily": "inter, 'Helvetica Neue', Arial, sans-serif",
	"paginationFontWeightActive": "500",
	"paginationItemBgActive": "#fff",
	"paginationItemLinkBg": "#fff",
	"paginationItemDisabledColorActive": "rgba(0, 0, 0, 0.25)",
	"paginationItemDisabledBgActive": "#e6e6e6",
	"paginationItemInputBg": "#fff",
	"paginationMiniOptionsSizeChangerTop": "0px",
	"pageHeaderPadding": "24px",
	"pageHeaderPaddingVertical": "16px",
	"pageHeaderPaddingBreadcrumb": "12px",
	"pageHeaderContentPaddingVertical": "12px",
	"pageHeaderBackColor": "#000",
	"pageHeaderGhostBg": "inherit",
	"pageHeaderHeadingTitle": "14px",
	"pageHeaderHeadingSubTitle": "14px",
	"pageHeaderTabsTabFontSize": "16px",
	"breadcrumbBaseColor": "#8c8c8c",
	"breadcrumbLastItemColor": "#262626",
	"breadcrumbFontSize": "14px",
	"breadcrumbIconFontSize": "14px",
	"breadcrumbLinkColor": "#8c8c8c",
	"breadcrumbLinkColorHover": "#262626",
	"breadcrumbSeparatorColor": "#8c8c8c",
	"breadcrumbSeparatorMargin": "0 8px",
	"sliderMargin": "10px 6px 10px",
	"sliderRailBackgroundColor": "#f5f5f5",
	"sliderRailBackgroundColorHover": "#e1e1e1",
	"sliderTrackBackgroundColor": "#b9d1fe",
	"sliderTrackBackgroundColorHover": "#8ab2fd",
	"sliderHandleBorderWidth": "2px",
	"sliderHandleBackgroundColor": "#fff",
	"sliderHandleColor": "#b9d1fe",
	"sliderHandleColorHover": "#8ab2fd",
	"sliderHandleColorFocus": "#568bf5",
	"sliderHandleColorFocusShadow": "rgba(44, 110, 242, 0.12)",
	"sliderHandleColorTooltipOpen": "#2C6EF2",
	"sliderHandleSize": "14px",
	"sliderHandleMarginTop": "-5px",
	"sliderHandleShadow": "0",
	"sliderDotBorderColor": "#f0f0f0",
	"sliderDotBorderColorActive": "#96b7f9",
	"sliderDisabledColor": "rgba(0, 0, 0, 0.25)",
	"sliderDisabledBackgroundColor": "#fff",
	"treeBg": "#fff",
	"treeTitleHeight": "24px",
	"treeChildPadding": "18px",
	"treeDirectorySelectedColor": "#fff",
	"treeDirectorySelectedBg": "#2C6EF2",
	"treeNodeHoverBg": "#f5f5f5",
	"treeNodeSelectedBg": "#d0e0fe",
	"collapseHeaderPadding": "12px 16px",
	"collapseHeaderPaddingExtra": "40px",
	"collapseHeaderBg": "#fafafa",
	"collapseContentPadding": "16px",
	"collapseContentBg": "#fff",
	"collapseHeaderArrowLeft": "16px",
	"skeletonColor": "rgba(190, 190, 190, 0.2)",
	"skeletonToColor": "rgba(129, 129, 129, 0.24)",
	"skeletonParagraphMarginTop": "28px",
	"skeletonParagraphLiMarginTop": "8px",
	"skeletonParagraphLiHeight": "16px",
	"skeletonTitleHeight": "16px",
	"skeletonTitleParagraphMarginTop": "24px",
	"transferHeaderHeight": "40px",
	"transferItemHeight": "32px",
	"transferDisabledBg": "#f5f5f5",
	"transferListHeight": "200px",
	"transferItemHoverBg": "#f5f5f5",
	"transferItemPaddingVertical": "6px",
	"transferListSearchIconTop": "12px",
	"messageNoticeContentPadding": "10px 16px",
	"messageNoticeContentBg": "#fff",
	"waveAnimationWidth": "6px",
	"alertSuccessBorderColor": "#b0f7ce",
	"alertSuccessBgColor": "#f0fff5",
	"alertSuccessIconColor": "#30d184",
	"alertInfoBorderColor": "#a8ceff",
	"alertInfoBgColor": "#f0f7ff",
	"alertInfoIconColor": "#2C6EF2",
	"alertWarningBorderColor": "#fffb8f",
	"alertWarningBgColor": "#feffe6",
	"alertWarningIconColor": "#fadb14",
	"alertErrorBorderColor": "#ffccc7",
	"alertErrorBgColor": "#fff2f0",
	"alertErrorIconColor": "#ff4d4f",
	"alertMessageColor": "rgba(0, 0, 0, 0.85)",
	"alertTextColor": "#262626",
	"alertCloseColor": "#8c8c8c",
	"alertCloseHoverColor": "rgba(0, 0, 0, 0.75)",
	"alertNoIconPaddingVertical": "8px",
	"alertWithDescriptionNoIconPaddingVertical": "15px",
	"alertWithDescriptionPaddingVertical": "15px",
	"alertWithDescriptionPadding": "15px 15px 15px 24px",
	"alertIconTop": "12.0005px",
	"alertWithDescriptionIconSize": "24px",
	"listHeaderBackground": "transparent",
	"listFooterBackground": "transparent",
	"listEmptyTextPadding": "16px",
	"listItemPadding": "12px 0",
	"listItemPaddingSm": "8px 16px",
	"listItemPaddingLg": "16px 24px",
	"listItemMetaMarginBottom": "16px",
	"listItemMetaAvatarMarginRight": "16px",
	"listItemMetaTitleMarginBottom": "12px",
	"listCustomizeCardBg": "#fff",
	"listItemMetaDescriptionFontSize": "14px",
	"statisticTitleFontSize": "14px",
	"statisticContentFontSize": "24px",
	"statisticUnitFontSize": "24px",
	"statisticFontFamily": "inter, 'Helvetica Neue', Arial, sans-serif",
	"drawerHeaderPadding": "16px 24px",
	"drawerBodyPadding": "24px",
	"drawerBg": "transparent",
	"drawerFooterPaddingVertical": "10px",
	"drawerFooterPaddingHorizontal": "16px",
	"drawerHeaderCloseSize": "56px",
	"timelineWidth": "2px",
	"timelineColor": "#f0f0f0",
	"timelineDotBorderWidth": "2px",
	"timelineDotColor": "#2C6EF2",
	"timelineDotBg": "#fff",
	"timelineItemPaddingBottom": "20px",
	"typographyTitleFontWeight": "600",
	"typographyTitleMarginTop": "1.2em",
	"typographyTitleMarginBottom": "0.5em",
	"uploadActionsColor": "#8c8c8c",
	"processTailColor": "#f0f0f0",
	"stepsNavArrowColor": "rgba(0, 0, 0, 0.25)",
	"stepsBackground": "#fff",
	"stepsIconSize": "32px",
	"stepsIconCustomSize": "32px",
	"stepsIconCustomTop": "0px",
	"stepsIconCustomFontSize": "24px",
	"stepsIconTop": "-0.5px",
	"stepsIconFontSize": "16px",
	"stepsIconMargin": "0 8px 0 0",
	"stepsTitleLineHeight": "32px",
	"stepsSmallIconSize": "24px",
	"stepsSmallIconMargin": "0 8px 0 0",
	"stepsDotSize": "8px",
	"stepsDotTop": "2px",
	"stepsCurrentDotSize": "10px",
	"stepsNavContentMaxWidth": "auto",
	"stepsVerticalIconWidth": "16px",
	"stepsVerticalTailWidth": "16px",
	"stepsVerticalTailWidthSm": "12px",
	"notificationBg": "#fff",
	"notificationPaddingVertical": "16px",
	"notificationPaddingHorizontal": "24px",
	"resultTitleFontSize": "24px",
	"resultSubtitleFontSize": "14px",
	"resultIconFontSize": "72px",
	"resultExtraMargin": "24px 0 0 0",
	"imageSizeBase": "48px",
	"imageFontSizeBase": "24px",
	"imageBg": "#f5f5f5",
	"imageColor": "#fff",
	"imagePreviewOperationSize": "18px",
	"imagePreviewOperationColor": "rgba(255, 255, 255, 0.85)",
	"imagePreviewOperationDisabledColor": "rgba(255, 255, 255, 0.25)"
};
module.exports = ___CSS_LOADER_EXPORT___;
